// extracted by mini-css-extract-plugin
module.exports = {"TextEditor":"TextEditor_TextEditor__3Kf3b"};